import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {blueGreenCards, blueRedCards, blueYellowCards, greenYellowCards, redGreenCards, redYellowCards} from '../cards-mockup';
import {clothColors} from '../clothColors';

@Component({
  selector: 'app-cards-color',
  templateUrl: './cards-color.component.html',
  styleUrls: ['./cards-color.component.css']
})
export class CardsColorComponent implements OnChanges, OnInit {

  @Input() level: number;
  @Input() counter: number;
  @Input() selectedColor: clothColors[];
  @Input() solved: boolean;
  @Input() onePlayer: boolean;
  @Input() turnCardNow: boolean;
  @Output() capShirtShortColor = new EventEmitter<clothColors[]>();
  @Output() clothBits = new EventEmitter<number[]>();

  cardsId: number[] = [];
  colorCardSet;
  cardIdClosed: number;
  capDominantCount: number;
  jacketDominantCount: number;
  pantsDominantCount: number;
  isActiveId = -1;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    // generate a new exercise
    if (changes.solved) {
      if (changes.solved.currentValue === true) {
        this.cardIdClosed = -1;
      }
    }
    if (changes.level || changes.counter) {
      this.generateRandomExercise();
    }
    if (changes.turnCardNow) {
      if (changes.turnCardNow.currentValue === true) {
        const rand = Math.floor((Math.random() * (this.cardsId.length - 1)));
        this.turnCard(rand);
      }
    }
  }

  ngOnInit() {
    // this.generateRandomExercise();
  }

  initAllValues() {
    this.cardsId = [];
    this.cardIdClosed = -1;
    this.capDominantCount = 0;
    this.jacketDominantCount = 0;
    this.pantsDominantCount = 0;
    this.isActiveId = -1;
  }

  generateRandomExercise() {
    this.initAllValues();

    let numberOfTotalCards = this.getNumberOfCards();

    if (!this.onePlayer) {
      // because we add one additional card at the end. to get even count for the dominant color.
      numberOfTotalCards --;
    }

    this.setColorCardSet();

    if (this.level !== 3) {
      // enough Biber Cards, no need to use a card twice
      this.getUniqueIds(numberOfTotalCards);
    } else {
      this.getIds(numberOfTotalCards);
    }

    if (!this.onePlayer) {
      // Add one last card so that the dominant color is even:
      this.addCardColorEven(numberOfTotalCards);
    } else {
      this.calculateClothBit();
    }
  }

  getNumberOfCards() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 3) + 4);
    } else if (this.level === 2) {
      return Math.floor((Math.random() * 3) + 8);
    } else {
      return Math.floor((Math.random() * 4) + 12);
    }
  }

  getIds(length: number) {
    let lastId = -1;
    for (let i = 0; i < length; i++) {
      let randomId;
      if (i % 2 === 0) {
        // Get a girl
        randomId = Math.floor((Math.random() * 7));
        // No 2 same colored Bibers one after the other.
        if (lastId - 8 === randomId) {
          randomId = this.generateOtherId(randomId, 0, 7);
        }
      } else {
        // Get a boy
        randomId = Math.floor((Math.random() * 7) + 8);
        if (lastId + 8 === randomId) {
          randomId = this.generateOtherId(randomId, 8, 7);
        }
      }
      lastId = randomId;
      this.cardsId.push( randomId );
      if (this.colorCardSet[randomId].capColor === this.selectedColor[0]) {
        this.capDominantCount ++;
      }
      if (this.colorCardSet[randomId].shirtColor === this.selectedColor[0]) {
        this.jacketDominantCount ++;
      }
      if (this.colorCardSet[randomId].shortColor === this.selectedColor[0]) {
        this.pantsDominantCount ++;
      }
    }
  }

  getUniqueIds(length: number) {
    let lastId = -1;
    for (let i = 0; i < length; i++) {
      let randomId;
      if (i % 2 === 0) {
        // Get a girl
        randomId = Math.floor((Math.random() * 7));
        while (this.cardsId.indexOf(randomId) !== -1 || randomId === lastId - 8) {
          randomId = this.generateOtherId(randomId, 0, 7);
        }
      } else {
        // Get a boy
        randomId = Math.floor((Math.random() * 7) + 8);
        while (this.cardsId.indexOf(randomId) !== -1 || randomId === lastId + 8) {
          randomId = this.generateOtherId(randomId, 8, 7);
        }
      }
      lastId = randomId;
      this.cardsId.push( randomId );
      if (this.colorCardSet[randomId].capColor === this.selectedColor[0]) {
        this.capDominantCount ++;
      }
      if (this.colorCardSet[randomId].shirtColor === this.selectedColor[0]) {
        this.jacketDominantCount ++;
      }
      if (this.colorCardSet[randomId].shortColor === this.selectedColor[0]) {
        this.pantsDominantCount ++;
      }
    }
  }

  setColorCardSet() {
    if (this.selectedColor.indexOf(clothColors.blue) !== -1 && this.selectedColor.indexOf(clothColors.red) !== -1) {
      this.colorCardSet = blueRedCards;
    }
    if (this.selectedColor.indexOf(clothColors.blue) !== -1 && this.selectedColor.indexOf(clothColors.green) !== -1) {
      this.colorCardSet = blueGreenCards;
    }
    if (this.selectedColor.indexOf(clothColors.blue) !== -1 && this.selectedColor.indexOf(clothColors.yellow) !== -1) {
      this.colorCardSet = blueYellowCards;
    }
    if (this.selectedColor.indexOf(clothColors.red) !== -1 && this.selectedColor.indexOf(clothColors.green) !== -1) {
      this.colorCardSet = redGreenCards;
    }
    if (this.selectedColor.indexOf(clothColors.red) !== -1 && this.selectedColor.indexOf(clothColors.yellow) !== -1) {
      this.colorCardSet = redYellowCards;
    }
    if (this.selectedColor.indexOf(clothColors.green) !== -1 && this.selectedColor.indexOf(clothColors.yellow) !== -1) {
      this.colorCardSet = greenYellowCards;
    }

  }

  addCardColorEven(numberOfTotalCards: number) {
    const addCard = [];
    if (this.capDominantCount % 2 === 0) {
      addCard.push(this.selectedColor[1]);
    } else {
      addCard.push(this.selectedColor[0]);
    }
    if (this.jacketDominantCount % 2 === 0) {
      addCard.push(this.selectedColor[1]);
    } else {
      addCard.push(this.selectedColor[0]);
    }
    if (this.pantsDominantCount % 2 === 0) {
      addCard.push(this.selectedColor[1]);
    } else {
      addCard.push(this.selectedColor[0]);
    }

    let idx;
    if (numberOfTotalCards % 2 === 0) {
      // Get a girl
      idx = 0;
    } else {
      // Get a boy
      idx = 8;
    }

    for ( idx; idx < this.colorCardSet.length; idx++) {
      if (this.colorCardSet[idx].capColor === addCard[0] &&
        this.colorCardSet[idx].shirtColor === addCard[1] &&
        this.colorCardSet[idx].shortColor === addCard[2]) {
        this.cardsId.push(idx);
        break;
      }
    }
  }

  calculateClothBit() {
    const bit = [];
    if (this.capDominantCount % 2 === 0) {
      bit.push(0);
    } else {
      bit.push(1);
    }
    if (this.jacketDominantCount % 2 === 0) {
      bit.push(0);
    } else {
      bit.push(1);
    }
    if (this.pantsDominantCount % 2 === 0) {
      bit.push(0);
    } else {
      bit.push(1);
    }

    this.clothBits.emit(bit);
  }

  generateOtherId (oldValue: number, start: number, length: number) {
    let randId = Math.floor((Math.random() * length) + start);
    while ( randId === oldValue) {
      randId = Math.floor((Math.random() * length) + start);
    }
    console.log(randId);
    return randId;
  }

  turnCard(i: number) {
    if (this.cardIdClosed === -1) {
      this.cardIdClosed = i;
      this.isActiveId = i;
    }

    const closedClothColors: clothColors[] = [];
    closedClothColors.push(this.colorCardSet[this.cardsId[i]].capColor);
    closedClothColors.push(this.colorCardSet[this.cardsId[i]].shirtColor);
    closedClothColors.push(this.colorCardSet[this.cardsId[i]].shortColor);

    console.log(closedClothColors);
    this.capShirtShortColor.emit(closedClothColors);
  }

  getImageSrc(i: number) {
    if (i !== this.cardIdClosed) {
      return this.colorCardSet[this.cardsId[i]].imageSrc;
    } else {
      return './assets/images/kartentricks/card_cover.png';
    }
  }

  getMaxSize() {
    if (this.level === 1) {
      return '13%';
    } else {
      return '10.5%';
    }
  }
}
